<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                           {{$t('add_gym')}}
                    </div>
                    <ValidationObserver v-slot="{ passes }">
                        <form @submit.prevent="passes(onSubmit)">

                            <base-input :name="$t('gym_name')" class="input-group-alternative mb-3"
                                        required
                                        rules="required"
                                        :placeholder="$t('gym_name')"
                                        :label="$t('gym_name')"
                                        v-model="form.name">
                            </base-input>

                            <base-input :name="$t('branch')" class="input-group-alternative mb-3"
                                        required
                                        rules="required"
                                        :placeholder="$t('branch')"
                                        :label="$t('branch')"
                                        v-model="form.branch">
                            </base-input>

                            <base-input :name="$t('description')" class="input-group-alternative mb-3"
                                        required
                                        rules="required|min:4"
                                        :placeholder="$t('description')"
                                        :label="$t('description')"
                                        v-model="form.description">
                            </base-input>

                            <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                        required
                                        rules="required|min:4"
                                        :placeholder="$t('address')"
                                        :label="$t('address')"
                                        v-model="form.address">
                            </base-input>

                            <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                        required
                                        rules="required|min:9"
                                        :placeholder="$t('phone')"
                                        :label="$t('phone')"
                                        v-model="form.contact_no">
                            </base-input>

                            <div class="text-center">
                                <base-button nativeType="submit" type="primary" class="my-4">{{$t('add_gym')}}</base-button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
        <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'addgym',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        form: {
            name: '',
            branch: '',
            description: '',
            address: '',
            contact_no: ''
        }
      }
    },
    created () {
        this.checkCurrentGyms()
    },
    updated () {
        this.checkCurrentGyms()
    },
    methods: {
        checkCurrentGyms () {
            if (this.$store.state.gyms) {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
            }
        },
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('gyms', {
                "name": this.form.name,
                "branch": this.form.branch,
                "description": this.form.description,
                "address": this.form.address,
                "contact_no": this.form.contact_no
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.getGyms()
            // this.$store.commit('addgyms', req.data.data)
            // this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
        },
        onSubmitFailed (req) {
            this.$store.commit('addgyms', '')
            this.modalAlert(req)
        },
        getGyms () {
            this.$http.get('gyms')
                .then(request => this.getGymsSuccessful(request))
                .catch(() => this.getGymsFailed())
        },
        getGymsSuccessful (req) {
            if (req.data.code !== '0') {
                this.getGymsFailed(req)
                return
            }
            this.$store.commit('addgyms', req.data.data)
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
        },
        getGymsFailed (req) {
            this.$store.commit('addgyms', '')
            this.modalAlert(req)
        }
    }
  }
</script>
<style>
</style>
